import type { AGENT_STATUS } from '@/constants';
import { createListStoreWithQuery } from '@/store/list-state.factory';

export type AgentStatusValue = 'All' | (typeof AGENT_STATUS)[number]['value'];

export type Filters = {
  status: AgentStatusValue;
};

export const useAgentsListStore = createListStoreWithQuery<Filters>('agents-list-state', {
  filterDefaults: {
    status: 'All',
  },
});
